import { render, staticRenderFns } from "./ModalCheckoutOrder.vue?vue&type=template&id=0bd150fc"
import script from "./ModalCheckoutOrder.vue?vue&type=script&lang=js"
export * from "./ModalCheckoutOrder.vue?vue&type=script&lang=js"
import style0 from "./ModalCheckoutOrder.vue?vue&type=style&index=0&id=0bd150fc&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports